const boardroom = {
  selectAdvisors: "Выберите советников",
  quickSelect: "Быстрый выбор",
  presetAll: "⚡ Все",
  presetBusiness: "🏛️ Бизнес",
  presetTechnical: "💻 Технический",
  readyQuestions: "Готовые вопросы",
  selectAndAsk: "Выберите советников и задайте вопрос",
  advisorsSelected: "советников выбрано",
  advisors: "советников",
  newQuestion: "Новый вопрос",
  askPlaceholder: "Спросите",
  toSend: "отправить",
  newLine: "новая строка",
  send: "Спросить",
  responses: "ответов",
  thinking: "Думает...",
} as const;
export default boardroom;
